import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceImportService } from "./service";

type InsuranceImportWithJobs = insuranceImportApiSpec.InsuranceImportWithJobs;

export const getInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.get<InsuranceImportWithJobs>(
    `/${insuranceImportId}`
  );

  return data;
};
